<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="heading"></ng-container>

        <tt-card>
            <ng-container *ngTemplateOutlet="filter"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <tt-list class="col-xs-12 sp-0" [ttData]="itemsListServiceObjects"></tt-list>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <ng-container *ngTemplateOutlet="heading"></ng-container>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="filter"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
            </tt-card>
        </div>

        <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>
</tt-page>

<ng-template #heading>
    <ng-container *ngIf="!!setting">
        <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>
    </ng-container>
</ng-template>

<ng-template #filter>
    <ng-container *ngIf="!!setting">
        <form class="form-horizontal sp-0" name="formServiceObjectsSearchText" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttRememberId="w_serviceobjects.searchtext" ttLabel="searchtext" [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" [ttButtons]="searchTextButtons" ttShowClearButton></tt-input>
        </form>

        <tt-checkbox *ngIf="argType !== '-'" ttLabel="show_all" [(ttModel)]="setting.show_all" (ttModelChange)="onChanged($event, 'show_all')"></tt-checkbox>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <tt-button-goto [ttText]="'serviceobjects_new'" (ttClick)="goToFunc('serviceobject')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </ng-container>
</ng-template>
